const RESTRICTIONS_LIST = ['School', 'Work', 'PE/Exercise', 'Lifting > 5lbs', 'Travel']

export default RESTRICTIONS_LIST
